import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("btc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const imgUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  if (p.startsWith("/")) return `${BACKEND_URL}${p}`;
  return `${API}/files/${p}`;
};

export function apiError(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
}
